import { cn } from "@/utils/theme";
import type { ReactNode } from "react";

const IconWrapper = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string | undefined;
}) => {
  return (
    <div
      className={cn(
        "size-7 rounded-lg bg-neutral-background border border-neutral-quiet flex items-center justify-center text-body",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default IconWrapper;
